import { IPickerOption } from "../OptionPicker/OptionPicker";

export const stallNumberPickerOptions: IPickerOption[] = [
  {
    id: "1",
    name: "1"
  },
  {
    id: "2",
    name: "2"
  },
  {
    id: "3",
    name: "3"
  },
  {
    id: "4",
    name: "4"
  },
  {
    id: "5",
    name: "5"
  },
  {
    id: "6",
    name: "6"
  },
  {
    id: "7",
    name: "7"
  },
  {
    id: "8",
    name: "8"
  },
  {
    id: "9",
    name: "9"
  },
  {
    id: "10",
    name: "10"
  },
  {
    id: "11",
    name: "11"
  },
  {
    id: "12",
    name: "12"
  },
  {
    id: "13",
    name: "13"
  },
  {
    id: "14",
    name: "14"
  },
  {
    id: "15",
    name: "15"
  },
  {
    id: "16",
    name: "16"
  },
  {
    id: "17",
    name: "17"
  },
  {
    id: "18",
    name: "18"
  },
  {
    id: "19",
    name: "19"
  },
  {
    id: "20",
    name: "20"
  },
  {
    id: "21",
    name: "21"
  },
  {
    id: "22",
    name: "22"
  },
  {
    id: "23",
    name: "23"
  },
  {
    id: "24",
    name: "24"
  },
  {
    id: "25",
    name: "25"
  },
  {
    id: "26",
    name: "26"
  },
  {
    id: "27",
    name: "27"
  },
  {
    id: "28",
    name: "28"
  },
  {
    id: "29",
    name: "29"
  },
  {
    id: "30",
    name: "30"
  },
  {
    id: "31",
    name: "31"
  },
  {
    id: "32",
    name: "32"
  },
  {
    id: "33",
    name: "33"
  },
  {
    id: "34",
    name: "34"
  },
  {
    id: "35",
    name: "35"
  },
  {
    id: "36",
    name: "36"
  },
  {
    id: "37",
    name: "37"
  },
  {
    id: "38",
    name: "38"
  },
  {
    id: "39",
    name: "39"
  },
  {
    id: "40",
    name: "40"
  },
  {
    id: "41",
    name: "41"
  },
  {
    id: "42",
    name: "42"
  },
  {
    id: "43",
    name: "43"
  },
  {
    id: "44",
    name: "44"
  },
  {
    id: "45",
    name: "45"
  },
  {
    id: "46",
    name: "46"
  },
  {
    id: "47",
    name: "47"
  },
  {
    id: "48",
    name: "48"
  },
  {
    id: "49",
    name: "49"
  },
  {
    id: "50",
    name: "50"
  },
  {
    id: "51",
    name: "51"
  },
  {
    id: "52",
    name: "52"
  },
  {
    id: "53",
    name: "53"
  },
  {
    id: "54",
    name: "54"
  },
  {
    id: "55",
    name: "55"
  },
  {
    id: "56",
    name: "56"
  },
  {
    id: "57",
    name: "57"
  },
  {
    id: "58",
    name: "58"
  },
  {
    id: "59",
    name: "59"
  },
  {
    id: "60",
    name: "60"
  },
  {
    id: "61",
    name: "61"
  },
  {
    id: "62",
    name: "62"
  },
  {
    id: "63",
    name: "63"
  },
  {
    id: "64",
    name: "64"
  },
  {
    id: "65",
    name: "65"
  },
  {
    id: "66",
    name: "66"
  },
  {
    id: "67",
    name: "67"
  },
  {
    id: "68",
    name: "68"
  },
  {
    id: "69",
    name: "69"
  },
  {
    id: "70",
    name: "70"
  },
  {
    id: "71",
    name: "71"
  },
  {
    id: "72",
    name: "72"
  },
  {
    id: "73",
    name: "73"
  },
  {
    id: "74",
    name: "74"
  },
  {
    id: "75",
    name: "75"
  },
  {
    id: "76",
    name: "76"
  },
  {
    id: "77",
    name: "77"
  },
  {
    id: "78",
    name: "78"
  },
  {
    id: "79",
    name: "79"
  },
  {
    id: "80",
    name: "80"
  },
  {
    id: "81",
    name: "81"
  },
  {
    id: "82",
    name: "82"
  },
  {
    id: "83",
    name: "83"
  },
  {
    id: "84",
    name: "84"
  },
  {
    id: "85",
    name: "85"
  },
  {
    id: "86",
    name: "86"
  },
  {
    id: "87",
    name: "87"
  },
  {
    id: "88",
    name: "88"
  },
  {
    id: "89",
    name: "89"
  },
  {
    id: "90",
    name: "90"
  },
  {
    id: "91",
    name: "91"
  },
  {
    id: "92",
    name: "92"
  },
  {
    id: "93",
    name: "93"
  },
  {
    id: "94",
    name: "94"
  },
  {
    id: "95",
    name: "95"
  },
  {
    id: "96",
    name: "96"
  },
  {
    id: "97",
    name: "97"
  },
  {
    id: "98",
    name: "98"
  },
  {
    id: "99",
    name: "99"
  },
  {
    id: "100",
    name: "100"
  },
  {
    id: "101",
    name: "101"
  },
  {
    id: "102",
    name: "102"
  },
  {
    id: "103",
    name: "103"
  },
  {
    id: "104",
    name: "104"
  },
  {
    id: "105",
    name: "105"
  },
  {
    id: "106",
    name: "106"
  },
  {
    id: "107",
    name: "107"
  },
  {
    id: "108",
    name: "108"
  },
  {
    id: "109",
    name: "109"
  },
  {
    id: "110",
    name: "110"
  },
  {
    id: "111",
    name: "111"
  },
  {
    id: "112",
    name: "112"
  },
  {
    id: "113",
    name: "113"
  },
  {
    id: "114",
    name: "114"
  },
  {
    id: "115",
    name: "115"
  },
  {
    id: "116",
    name: "116"
  },
  {
    id: "117",
    name: "117"
  },
  {
    id: "118",
    name: "118"
  },
  {
    id: "119",
    name: "119"
  },
  {
    id: "120",
    name: "120"
  },
  {
    id: "121",
    name: "121"
  },
  {
    id: "122",
    name: "122"
  },
  {
    id: "123",
    name: "123"
  },
  {
    id: "124",
    name: "124"
  },
  {
    id: "125",
    name: "125"
  },
  {
    id: "126",
    name: "126"
  },
  {
    id: "127",
    name: "127"
  },
  {
    id: "128",
    name: "128"
  },
  {
    id: "129",
    name: "129"
  },
  {
    id: "130",
    name: "130"
  },
  {
    id: "131",
    name: "131"
  },
  {
    id: "132",
    name: "132"
  },
  {
    id: "133",
    name: "133"
  },
  {
    id: "134",
    name: "134"
  },
  {
    id: "135",
    name: "135"
  },
  {
    id: "136",
    name: "136"
  },
  {
    id: "137",
    name: "137"
  },
  {
    id: "138",
    name: "138"
  },
  {
    id: "139",
    name: "139"
  },
  {
    id: "140",
    name: "140"
  },
  {
    id: "141",
    name: "141"
  },
  {
    id: "142",
    name: "142"
  },
  {
    id: "143",
    name: "143"
  },
  {
    id: "144",
    name: "144"
  },
  {
    id: "145",
    name: "145"
  },
  {
    id: "146",
    name: "146"
  },
  {
    id: "147",
    name: "147"
  },
  {
    id: "148",
    name: "148"
  },
  {
    id: "149",
    name: "149"
  },
  {
    id: "150",
    name: "150"
  },
  {
    id: "151",
    name: "151"
  },
  {
    id: "152",
    name: "152"
  },
  {
    id: "153",
    name: "153"
  },
  {
    id: "154",
    name: "154"
  },
  {
    id: "155",
    name: "155"
  },
  {
    id: "156",
    name: "156"
  },
  {
    id: "157",
    name: "157"
  },
  {
    id: "158",
    name: "158"
  },
  {
    id: "159",
    name: "159"
  },
  {
    id: "160",
    name: "160"
  },
  {
    id: "161",
    name: "161"
  },
  {
    id: "162",
    name: "162"
  },
  {
    id: "163",
    name: "163"
  },
  {
    id: "164",
    name: "164"
  },
  {
    id: "165",
    name: "165"
  },
  {
    id: "166",
    name: "166"
  },
  {
    id: "167",
    name: "167"
  },
  {
    id: "168",
    name: "168"
  },
  {
    id: "169",
    name: "169"
  },
  {
    id: "170",
    name: "170"
  },
  {
    id: "171",
    name: "171"
  },
  {
    id: "172",
    name: "172"
  },
  {
    id: "173",
    name: "173"
  },
  {
    id: "174",
    name: "174"
  },
  {
    id: "175",
    name: "175"
  },
  {
    id: "176",
    name: "176"
  },
  {
    id: "177",
    name: "177"
  },
  {
    id: "178",
    name: "178"
  },
  {
    id: "179",
    name: "179"
  },
  {
    id: "180",
    name: "180"
  },
  {
    id: "181",
    name: "181"
  },
  {
    id: "182",
    name: "182"
  },
  {
    id: "183",
    name: "183"
  },
  {
    id: "184",
    name: "184"
  },
  {
    id: "185",
    name: "185"
  },
  {
    id: "186",
    name: "186"
  },
  {
    id: "187",
    name: "187"
  },
  {
    id: "188",
    name: "188"
  },
  {
    id: "189",
    name: "189"
  },
  {
    id: "190",
    name: "190"
  },
  {
    id: "191",
    name: "191"
  },
  {
    id: "192",
    name: "192"
  },
  {
    id: "193",
    name: "193"
  },
  {
    id: "194",
    name: "194"
  },
  {
    id: "195",
    name: "195"
  },
  {
    id: "196",
    name: "196"
  },
  {
    id: "197",
    name: "197"
  },
  {
    id: "198",
    name: "198"
  },
  {
    id: "199",
    name: "199"
  },
  {
    id: "200",
    name: "200"
  }
];
